import { z } from 'zod';
import { FeedbackVerdict } from '../enums';

export const SCORING_FEEDBACK_PAGE_SIZES = [25, 50, 100] as const;

export const ScoringFeedbackQuery = z
  .object({
    cycleId: z.string().uuid().optional(),
    verdict: FeedbackVerdict.optional(),
    promptVersion: z.string().trim().min(1).max(64).optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
  })
  .refine((v) => !v.from || !v.to || Date.parse(v.from) < Date.parse(v.to), { message: 'from must be before to', path: ['to'] });
export type ScoringFeedbackQuery = z.infer<typeof ScoringFeedbackQuery>;

export const ScoringFeedbackSummaryRow = z.object({
  promptVersion: z.string(),
  confirms: z.number().int(),
  rejects: z.number().int(),
  rejectRate: z.number(),
});
export type ScoringFeedbackSummaryRow = z.infer<typeof ScoringFeedbackSummaryRow>;

export const ScoringFeedbackItem = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  verdict: FeedbackVerdict,
  comment: z.string().nullable(),
  aiScore: z.number().int().nullable(),
  promptVersion: z.string(),
  assessmentId: z.string().uuid(),
  householdId: z.string().uuid(),
  familyName: z.string(),
  authorName: z.string(),
});
export type ScoringFeedbackItem = z.infer<typeof ScoringFeedbackItem>;

export const ScoringFeedbackList = z.object({
  cycleId: z.string().uuid(),
  summary: z.array(ScoringFeedbackSummaryRow),
  items: z.array(ScoringFeedbackItem),
  total: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
});
export type ScoringFeedbackList = z.infer<typeof ScoringFeedbackList>;

export const rejectRate = (confirms: number, rejects: number): number => (confirms + rejects ? rejects / (confirms + rejects) : 0);
